import { RefObject, useRef } from 'react';
import { SliderState } from '@react-stately/slider';
import { useFocusRing } from '@react-aria/focus';
import { VisuallyHidden } from '@react-aria/visually-hidden';
import { mergeProps } from '@react-aria/utils';
import { useSliderThumb } from '@react-aria/slider';
import { SliderThumbCircle } from './atoms';

type SliderThumbProps = {
  index: number;
  percentValue: number;
  state: SliderState;
  trackRef: RefObject<null>;
  hasError?: boolean;
  thumbColor?: string;
};

export const SliderThumb = ({ percentValue, ...props }: SliderThumbProps) => {
  const { state, trackRef, index, hasError, thumbColor } = props;
  const inputRef = useRef(null);
  const { thumbProps, inputProps } = useSliderThumb(
    { index, trackRef, inputRef },
    state
  );

  const { focusProps, isFocusVisible } = useFocusRing();
  return (
    <SliderThumbCircle
      {...thumbProps}
      style={{ left: `${percentValue}%` }}
      $isDragging={state.isThumbDragging(index)}
      $isFocused={isFocusVisible}
      $hasError={hasError}
      $thumbColor={thumbColor}
    >
      <VisuallyHidden>
        <input ref={inputRef} {...mergeProps(inputProps, focusProps)} />
      </VisuallyHidden>
    </SliderThumbCircle>
  );
};
